import { css, Theme } from "@emotion/react";

export const link = (theme: Theme) =>
    css({
        color: theme.candy.typography.link.color,
        textDecoration: "none",
        cursor: "pointer",
    });
